import {useQuery} from "@tanstack/react-query"
import {studentPaymentService} from "services"
import {PaymentProvider} from "types/student-account/student-payment"

const queryCacheKey = "payment-provider-configs"

export const usePaymentProviderConfigs = (profileId?: number) => {
    const query = useQuery(
        [queryCacheKey, profileId],
        async () => await studentPaymentService.getPaymentProviderConfigs({profileId}),
        {
            refetchOnWindowFocus: false,
            refetchOnMount: false,
            refetchOnReconnect: false,
            staleTime: Infinity
        }
    )

    const configs = query.data ?? []

    return {
        paymentProviderConfigs: configs,
        isStripeEnabled: configs.some((c: {provider: string}) => c.provider === PaymentProvider.Stripe),
        isPaypalEnabled: configs.some((c: {provider: string}) => c.provider === PaymentProvider.Paypal),
        isAuthorizeNetEnabled: configs.some((c: {provider: string}) => c.provider === PaymentProvider.AuthorizeNet),
        paypalProviderConfig: configs.find((c: {provider: string}) => c.provider === PaymentProvider.Paypal) as
            | {provider: string; clientId: string; minimumChargeAmountForCurrency?: Record<string, number>}
            | undefined,
        isLoading: query.isFetching,
        refetch: query.refetch
    }
}
